import React from 'react';
import columns from './columns';
import PreviewStepBase from '#/modules/admin/dataImport/components/base/PreviewStepBase';

export interface CapitalNeedPreviewStepProps {
  rows: Record<string, unknown>[];
}

const CapitalNeedPreviewStep: React.FC<CapitalNeedPreviewStepProps> = ({ rows }) => {
  return (
    <PreviewStepBase
      dataGridId="capital-need-excel-import-preview"
      pluralText="Capital Needs"
      singularText="Capital Need"
      columns={columns}
      dataSource={rows}
      noColumnChooser={true}
      defaultPageSize={10}
      disableSorting={false}
      disableFiltering={false}
    />
  );
};

export default React.memo(CapitalNeedPreviewStep);
